import { Routes } from "react-router-dom";
import {ROUTES} from "../../constants";

export const COMPONENTS_CARDS = [
    {
        name: 'Call Score',
        subtitle: 'Shows overall and criteria-level scores along with feedback',
        disabled: false,
        viewButton: {
            redirectPath: ROUTES.VIEW_CALL_SCORE,
            disable: false
        },
        testButton: {
            redirectPath: ROUTES.CALL_SCORE,
            disable: false
        }
    },
    {
        name: 'Insights UI',
        subtitle: 'Provides detailed insights from a call, including sentiment analysis and Q&A',
        disabled: false,
        viewButton: {
            redirectPath: ROUTES.VIEW_INSIGHTS_UI_DETAILS,
            disable: false
        },
        testButton: {
            redirectPath: null,
            disable: true
        }
    },
    {
        name: 'Insights UI - List',
        subtitle: 'Shows a list of relevant calls, each with a quick snapshot',
        disabled: false,
        viewButton: {
            redirectPath: ROUTES.VIEW_INSIGHTS_UI_LIST,
            disable: false
        },
        testButton: {
            redirectPath: null,
            disable: true
        }
    }
    // {
    //     name: 'Call Summary',
    //     disabled: false,
    //     viewButton: {
    //         redirectPath: null,
    //         disable: true
    //     },
    //     testButton: {
    //         redirectPath: null,
    //         disable: true
    //     },
    //     documentationLink: null
    // },
    // {
    //     name: 'Call Sentiment',
    //     disabled: false,
    //     viewButton: {
    //         redirectPath: null,
    //         disable: true
    //     },
    //     testButton: {
    //         redirectPath: null,
    //         disable: true
    //     },
    //     documentationLink: null
    // },
    // {
    //     name: 'Topics',
    //     disabled: false,
    //     viewButton: {
    //         redirectPath: null,
    //         disable: true
    //     },
    //     testButton: {
    //         redirectPath: null,
    //         disable: true
    //     },
    //     documentationLink: null
    // },
    // {
    //     name: 'Transcription',
    //     disabled: false,
    //     viewButton: {
    //         redirectPath: null,
    //         disable: true
    //     },
    //     testButton: {
    //         redirectPath: null,
    //         disable: true
    //     },
    //     documentationLink: null
    // },
    // {
    //     name: 'Next Steps',
    //     disabled: false,
    //     viewButton: {
    //         redirectPath: null,
    //         disable: true
    //     },
    //     testButton: {
    //         redirectPath: null,
    //         disable: true
    //     },
    //     documentationLink: null
    // },
    // {
    //     name: 'Objections',
    //     disabled: false,
    //     viewButton: {
    //         redirectPath: null,
    //         disable: true
    //     },
    //     testButton: {
    //         redirectPath: null,
    //         disable: true
    //     },
    //     documentationLink: null
    // },
    // {
    //     name: 'Q&A',
    //     disabled: false,
    //     viewButton: {
    //         redirectPath: null,
    //         disable: true
    //     },
    //     testButton: {
    //         redirectPath: null,
    //         disable: true
    //     },
    //     documentationLink: null
    // }
]